import { flexRender, type RowData } from '@tanstack/react-table';
import type { TableInstance } from '../tableFeatures';

interface TableFooterProps<TData extends RowData> {
  table: TableInstance<TData>;
}

export function TableFooter<TData extends RowData>({
  table,
}: TableFooterProps<TData>) {
  const includesData = table.getFooterGroups().some((groups) => {
    return groups.headers.some((group) => group.column.columnDef.footer);
  });

  if (!includesData) return null;

  return (
    <tfoot className="group/footer">
      {table.getFooterGroups().map((footerGroup) => (
        <tr key={footerGroup.id} className="group/row">
          {footerGroup.headers.map((header) => (
            <th key={header.id}>
              {header.isPlaceholder
                ? null
                : flexRender(
                    header.column.columnDef.footer,
                    header.getContext(),
                  )}
            </th>
          ))}
        </tr>
      ))}
    </tfoot>
  );
}
